<template>
  <div>
    <iframe
      ref="qrcodeIframe"
      id="qrcodeIframe"
      scrolling="no"
      width="265"
      height="265"
      frameBorder="0"
      allowTransparency="true"
      :src="src"
    ></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      inlineStyles: [
        '.impowerBox .qrcode {width: 265px;}',
        '.impowerBox .title {display: none;}',
        '.impowerBox .info {display: none;}',
        '.status_icon {display: none}',
        '.impowerBox .status {text-align: center;}',
        '.impowerBox .qrcode {margin-top: 0;}'
      ]
    }
  },
  computed: {
    encodedRedirectUri() {
      return encodeURIComponent(this.redirect_uri)
    },
    inlineStylesHref() {
      return this.css !== ''
        ? this.css
        : 'data:text/css;base64,' + window.btoa(this.inlineStyles.join('\n'))
    },
    src() {
      return `https://open.weixin.qq.com/connect/qrconnect?appid=${this.appid}&scope=${this.scope}&redirect_uri=${this.encodedRedirectUri}&state=${this.state}&login_type=jssdk&self_redirect=true&style=${this.theme}&href=${this.inlineStylesHref}`
    }
  },
  props: {
    //应用唯一标识，在微信开放平台提交应用审核通过后获得
    appid: {
      type: String,
      default: process.env.VUE_APP_WX_APP_ID || ''
    },
    //应用授权作用域，拥有多个作用域用逗号（,）分隔，网页应用目前仅填写snsapi_login即可
    scope: {
      type: String,
      default: 'snsapi_login'
    },
    //重定向地址，需要进行UrlEncode
    redirect_uri: {
      type: String,
      default: process.env.VUE_APP_BASE_URL
        ? `${process.env.VUE_APP_BASE_URL}wechat/login/`
        : ''
    },
    //用于保持请求和回调的状态，授权请求后原样带回给第三方。该参数可用于防止csrf攻击（跨站请求伪造攻击），建议第三方带上该参数，可设置为简单的随机数加session进行校验
    state: {
      type: String,
      default: ''
    },
    //提供"black"、"white"可选，默认为黑色文字描述。详见文档底部FAQ
    theme: {
      type: String,
      default: 'black'
    },
    // 自定义样式链接，第三方可根据实际需求覆盖默认样式。详见文档底部FAQ
    css: {
      type: String,
      default: ''
    }
  },
  mounted() {
    let _this = this
    // 在外部vue的window上添加postMessage的监听，并且绑定处理函数
    window.addEventListener('message', function(event) {
      const data = event.data
      switch (data.cmd) {
        case 'login':
          _this.$store.commit('SubscriberStore/fetch', data.params.data) // 获取个人信息
          break
        case 'refresh':
          document.getElementById('qrcodeIframe').contentWindow.location.href =
            _this.src
          break
      }
    })
    console.log(process.env) // eslint-disable-line no-console
  }
}
</script>
